export const setCookie = (name: string, value: string, expiresInDays = 7) => {
    const date = new Date()
    date.setTime(date.getTime() + expiresInDays * 24 * 60 * 60 * 1000)

    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`
}

export const getCookie = (name: string): string | null => {
    const allCookies = document.cookie.split(';')
    for (const cookie of allCookies) {
        const split = cookie.split('=')
        if (split[0].trim() === name) {
            return 'Y'
        }
    }

    return null
}

export const deleteCookie = (name: string) => {
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}
